import { GAME_ID, REDUX_ACTIONS, MASTERY_SCORE } from '../../data/constants';

const initialState = {
  helpIndex: 0,
  actionIndex: 0,
  storiesPlayed: 0,
  correctStories: 0,
};

const reportingDetailsReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.INCREMENT_HELP_INDEX:
      return {
        ...state,
        helpIndex: state.helpIndex + 1,
      };

    case REDUX_ACTIONS.INCREMENT_LEVEL_SCORE:
      return {
        ...state,
        correctStories: state.correctStories + 1,
      };

    case REDUX_ACTIONS.INCREMENT_ACTION_INDEX:
      return {
        ...state,
        actionIndex: state.actionIndex + 1,
      };

    case REDUX_ACTIONS.INCREMENT_STORIES_PLAYED:
      return {
        ...state,
        storiesPlayed: state.storiesPlayed + 1,
      };

    case REDUX_ACTIONS.MAX_LEVEL_SCORE:
      return {
        ...state,
        correctStories: MASTERY_SCORE,
        storiesPlayed: MASTERY_SCORE,
      };

    case REDUX_ACTIONS.QUICK_FAIL_ROUND:
      return {
        ...state,
        storiesPlayed: MASTERY_SCORE,
        actionIndex: MASTERY_SCORE,
      };

    case REDUX_ACTIONS.RESET_TRACKED_INDICES:
      return {
        ...state,
        helpIndex: 0,
        actionIndex: 0,
        storiesPlayed: payload.resetStoriesPlayed ? 0 : state.storiesPlayed,
        correctStories: payload.resetStoriesPlayed ? 0 : state.correctStories,
      };

    default:
      return state;
  }
};

export default reportingDetailsReducer;
